export default __webpack_public_path__ + "ad4f5a10d4564f1354ff36edcd950b4f.jpeg";